import { useQuery } from "@tanstack/react-query";
import ConfigDesks from "@/services/configDesks";
import GetAllClientes from "@/services/getClientes";
import CadastroAgenciaService from "@/services/cadastroAgencia";
import ServiceRepresentantes from "@/services/serviceRepresentante";

// Hook para buscar status de desks
export const useStatus = () => {
  return useQuery({
    queryKey: ["desk-status"],
    queryFn: async () => {
      const response = await ConfigDesks.getTypeStatusDesk();
      if (response.status !== 200) {
        throw new Error("Não foi possível buscar Tipos de Desk");
      }
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
    enabled: !!localStorage.getItem("token"),
  });
};

// Hook para buscar clientes
export const useClients = () => {
  return useQuery({
    queryKey: ["clients"],
    queryFn: async () => {
      const response = await GetAllClientes.listClientesPagination(1, 99999);
      if (response.status !== 200) {
        throw new Error("Não foi possível buscar clientes");
      }
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
    enabled: !!localStorage.getItem("token"),
  });
};

// Hook para buscar agências
export const useAgencies = () => {
  return useQuery({
    queryKey: ["agencies"],
    queryFn: async () => {
      const response = await CadastroAgenciaService.listarAgencys(1, 9999);
      if (response.status !== 200) {
        throw new Error("Não foi possível buscar agências");
      }
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
};

// Hook para buscar representantes
export const useRepresentatives = () => {
  return useQuery({
    queryKey: ["representatives"],
    queryFn: async () => {
      const response = await ServiceRepresentantes.listRepresentantes(
        1,
        9999999
      );
      if (response.status !== 200) {
        throw new Error("Não foi possível buscar representantes");
      }
      return response.data.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
    enabled: !!localStorage.getItem("token"),
  });
};

// Hook combinado para buscar todos os dados necessários
export const useTimelineData = () => {
  const statusQuery = useStatus();
  const clientsQuery = useClients();
  const agenciesQuery = useAgencies();
  const representativesQuery = useRepresentatives();

  return {
    status: statusQuery?.data?.data,
    clients: clientsQuery?.data?.data,
    agencies: agenciesQuery?.data?.data,
    representatives: representativesQuery.data,
    isLoading:
      statusQuery.isLoading ||
      clientsQuery.isLoading ||
      agenciesQuery.isLoading ||
      representativesQuery.isLoading,
    error:
      statusQuery.error ||
      clientsQuery.error ||
      agenciesQuery.error ||
      representativesQuery.error,
  };
};
